import { REVIEWS_TAB_TITLE } from './constants'
import { isDefined } from 'helpers/utils'

export const tabsConfig = (reviewsCount, bvId, tireSizesCount) => [
  {
    title: 'Sizes',
    value: tireSizesCount || ''
  },
  {
    title: 'Specifications' },
  ...(bvId ? [{
    title: isDefined(reviewsCount) ?
      `${REVIEWS_TAB_TITLE} (${reviewsCount})` :
      REVIEWS_TAB_TITLE
  }] : [])
]
